"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/**
 * Async wait for a variable till it gets defined in a parent
 *
 * Note: If you intend to use on the server, pass the appropriate parent.
 *
 * Usage Example: Waiting for async window.AppleID var to be initialized
 * - eg: `waitForVar('AppleID').then(AppleID => AppleID.init())`
 * - eg: `waitForVar('AppleID', { pollFrequency: 500, retries: 2, parent: window || global }).then(AppleID => AppleID.init())`
 */

const waitForVar = async function (name) {
  let {
    pollFrequency = 1000,
    retries: inRetries = 5,
    parent = window
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    pollFrequency: 1000,
    retries: 5,
    parent: window
  };
  if (Object.prototype.hasOwnProperty.call(parent, name)) {
    return parent[name];
  }
  if (!inRetries) {
    return null;
  }
  const retries = inRetries - 1;
  await new Promise(resolve => {
    setTimeout(resolve, pollFrequency);
  });
  return waitForVar(name, {
    pollFrequency,
    parent,
    retries
  });
};
var _default = exports.default = waitForVar;